import styled, { css } from 'styled-components'
import fadeIn from '../../../styles/animations/fadeIn'
import { darken } from 'polished'

interface FieldProps {
  readonly error: boolean
}

export const Container = styled.div`
  ${fadeIn};
  height: 100%;
`

export const Content = styled.div<any>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0px 8px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #0f172a;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: #94a3b8;
  }

  &:focus-within {
    border-color: #0284c7;
    box-shadow: 0 0 0 3px rgba(2, 132, 199, 0.15);
  }
`
